<template>
  <el-dialog title="" :center="true" :visible.sync="particularsVisible">
    <div class="particulars-view">
      <div class="descriptions-title-view">
        视频信息详情
      </div>
      <div class="descriptions-view">
        <div class="descriptions-item">
          <div class="descriptions-item-view">
            <div class="descriptions-title">
              <el-tag size="medium">发布人:</el-tag>
            </div>
            <div class="descriptions-value">
              {{handleTypeByValue(particularsData.platformUserId,platformUserOptions)}}
            </div>
          </div>
          <div class="descriptions-item-view">
            <div class="descriptions-title">
              <el-tag size="medium">视频标题:</el-tag>
            </div>
            <div class="descriptions-value">
              {{particularsData.videoTitle}}
            </div>
          </div>
        </div>
        <div class="descriptions-item">
          <div class="descriptions-item-view">
            <div class="descriptions-title">
              <el-tag size="medium">视频简介:</el-tag>
            </div>
            <div class="descriptions-value">
              {{particularsData.videoText}}
            </div>
          </div>
        </div>
        <div class="descriptions-item">
          <div class="descriptions-item-view">
            <div class="descriptions-title">
              <el-tag size="medium">封面图片:</el-tag>
            </div>
            <div class="descriptions-value">
              <img @click="handlePreView(handleImageUrl(particularsData.faceUrl))"
                   :src="handleImageUrl(particularsData.faceUrl)" style="width: 30px;height: 30px;border-radius: 5px;"/>
            </div>
          </div>
          <div class="descriptions-item-view">
            <div class="descriptions-title">
              <el-tag size="medium">访问地址:</el-tag>
            </div>
            <div class="descriptions-value">
              <el-tag size="medium" @click="handlePreviewVideo(particularsData)">点击预览</el-tag>
            </div>
          </div>
          <div class="descriptions-item-view">
            <div class="descriptions-title">
              <el-tag size="medium">点赞数:</el-tag>
            </div>
            <div class="descriptions-value">
              {{particularsData.tagNum}}
            </div>
          </div>
          <div class="descriptions-item-view">
            <div class="descriptions-title">
              <el-tag size="medium">平均评分:</el-tag>
            </div>
            <div class="descriptions-value">
              {{particularsData.starNum}}
            </div>
          </div>
          <div class="descriptions-item-view">
            <div class="descriptions-title">
              <el-tag size="medium">视频状态:</el-tag>
            </div>
            <div class="descriptions-value">
              {{handleTypeByValue(particularsData.videoStatus,videoStatusOption)}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--视频预览-->
    <el-dialog :visible.sync="previewVideoVisible" append-to-body title="视频预览">
      <div class="video-item">
        <vueMiniPlayer ref="vueMiniPlayer"
                       :video="videoItem" :mutex="true"
                       @fullscreen="handleFullscreen" />
      </div>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="previewVisible"  title="图片预览">
      <img width="100%" :src="previewImageUrl" alt="" />
    </el-dialog>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import Api from "@/services";
  import baseUtils from '@/utils/baseUtils'
  export default {
    name: "ItemParticulars",
    components:{
      Api:Api,
      baseUtils:baseUtils,
    },
    data() {
      return {
        //-----------------------------
        videoStatusOption:this.$commonOptions.videoStatusOption,
        platformUserOptions:[],
        videoItem:{
          url: '',
          cover: '',
          muted: false,
          loop: false,
          preload: 'auto',
          poster: '',
          volume: 1,
          autoplay: false
        },
        previewVideoVisible:false,
        //-----------------------------
        authUserOptions:[],
        particularsVisible:false,
        particularsData:{},
        size:'',
        previewImageUrl:'',
        previewVisible:false,
      }
    },
    methods:{
      //视频预览
      handlePreviewVideo(data){
        console.log('handlePreviewVideo:'+JSON.stringify(data))
        if(!data){
          return;
        }
        let faceUrl = data.faceUrl
        let videoUrl = data.videoUrl

        this.videoItem.url = this.handleFileUrl(videoUrl)
        this.videoItem.cover = this.handleFileUrl(faceUrl)

        this.previewVideoVisible = true;
      },
      handleFullscreen(){},
      async queryAllPlatformUser(){
        try {
          const loading = this.$loading({
            lock: true,
            text: "正在请求。。。",
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.8)'
          });
          Api.queryAllPlatformUser({}).then((res) => {
            if (res.success) {
              console.log('res:'+JSON.stringify(res))
              if(this.$isNull(res)){
                return;
              }
              let data = res.data
              if(this.$isNull(data)){
                return;
              }
              this.platformUserOptions = new Array();
              data.map((item) => {
                let options = {
                  'text':item.userName,
                  'value':item.platformUserId
                }
                this.platformUserOptions.push(options)
              })
              console.log('this.platformUserOptions:'+JSON.stringify(this.platformUserOptions))
              loading.close();
            } else {
              loading.close();
              this.$message.error('服务器异常');
            }
          });
        } catch (error) {
          loading.close();
          this.$message.error(error.message || error.msg || "服务器异常");
        }
      },
      handlePreView(url){
        if(this.$isNull(url)){
          return;
        }
        this.previewImageUrl = url
        this.previewVisible = true
      },
      handleTypeByValue(value,optionList){
        //console.log('optionList:'+JSON.stringify(optionList))
        if(this.$isNull(value)){
          console.log('返回空')
          return '无'
        }
        if(this.$isNull(optionList)){
          console.log('optionList返回空')
          return '';
        }
        let result =
                optionList.find(item => item.value == value);
        //console.log('result:'+JSON.stringify(result))
        if(!this.$isNull(result)){
          return result.text
        }else{
          return '无'
        }
      },
      showParticulars(data) {
        console.log('data:'+JSON.stringify(data))
        if(!this.$isNull(data)){
          this.particularsData = {
            ...data
          }
        }
        this.particularsVisible = true;
      },
      async init(data){
        await this.queryAllPlatformUser();
        this.authUserOptions = await this.$commonConstants.authUserOptions()
        this.showParticulars(data);
      },
      handleCancel(){
        this.particularsVisible = false
        this.clearAll();
      },
      clearAll(){
        this.particularsVisible = false
      },
    },
    created() {

    }
  }
</script>

<style scoped lang="scss">
.particulars-view{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  align-content: center;
  .descriptions-title-view{
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 10px;
  }
  .descriptions-view{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    align-content: center;
    .descriptions-item{
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-around;
      .descriptions-item-view{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-size: 15px;
         .descriptions-title{
           font-weight: bold;
           padding: 10px 5px;
         }
         .descriptions-value{
           font-weight: bold;
           padding: 10px 5px;
         }
       }
     }
   }
}
</style>



// WEBPACK FOOTER //
// ItemParticulars.vue?6e4f41b5